import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { observable, runInAction } from 'mobx';
import { FileDownload } from '../../../shared/document/FileDownload';
import { SalesDashboardExcelFileLayer } from '../../transportLayers/settings/SalesDashboardExcelFileLayer';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
export var SalesDashboardExcelFileStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(SalesDashboardExcelFileStore, _BaseStore);

  function SalesDashboardExcelFileStore() {
    var _this;

    _classCallCheck(this, SalesDashboardExcelFileStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SalesDashboardExcelFileStore).apply(this, arguments));
    _this.name = StoreName.SDRExcelFile;
    /** Layer contains methods for fetching data */

    _this.salesDashboardExcelFileLayer = new SalesDashboardExcelFileLayer();
    /** List of SalesDashboardExcelFiles */

    _this.list = new Map();

    _this.getAll = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var salesFiles;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.salesDashboardExcelFileLayer.findAll();

              case 2:
                salesFiles = _context.sent;
                this.list.clear();
                runInAction(function () {
                  salesFiles.forEach(function (file) {
                    _this2.list = _this2.list.set(file.id, file);
                  });
                });
                return _context.abrupt("return", salesFiles);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };

    _this.download = function (id) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var response, download;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.salesDashboardExcelFileLayer.download(id);

              case 2:
                response = _context2.sent;
                download = new FileDownload(response.data, response.headers);
                return _context2.abrupt("return", download.process());

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    };

    return _this;
  }

  return SalesDashboardExcelFileStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Map)], SalesDashboardExcelFileStore.prototype, "list", void 0);